import IconRemove from '../../components/icons/IconRemove';
import IconAdd from '../../components/icons/IconAdd';

export default function DraftReview({ questions, onChange }) {
  const updateQuestionText = (qIndex, text) => {
    const next = [...questions];
    next[qIndex] = { ...next[qIndex], text };
    onChange(next);
  };

  const updateOption = (qIndex, oIndex, patch) => {
    const next = [...questions];
    const options = [...next[qIndex].options];
    options[oIndex] = { ...options[oIndex], ...patch };
    next[qIndex] = { ...next[qIndex], options };
    onChange(next);
  };

  const removeOption = (qIndex, oIndex) => {
    const next = [...questions];
    next[qIndex] = { ...next[qIndex], options: next[qIndex].options.filter((_, i) => i !== oIndex) };
    onChange(next);
  };

  const addOption = (qIndex) => {
    const next = [...questions];
    next[qIndex] = { ...next[qIndex], options: [...next[qIndex].options, { text: '', isRight: false, points: 0 }] };
    onChange(next);
  };

  const removeQuestion = (qIndex) => {
    onChange(questions.filter((_, i) => i !== qIndex));
  };

  return (
    <div className="ai-draft-list">
      {questions.map((question, qIndex) => (
        <div className="ai-draft-question" key={qIndex}>
          <div className="ai-draft-question-header">
            <span className="ai-draft-question-num">{qIndex + 1}.</span>
            <textarea
              className="ai-draft-question-text"
              value={question.text}
              onChange={e => updateQuestionText(qIndex, e.target.value)}
            />
            <span className="ai-draft-remove" onClick={() => removeQuestion(qIndex)}>
              <IconRemove />
            </span>
          </div>
          <div className="ai-draft-options">
            {question.options.map((option, oIndex) => (
              <div className="ai-draft-option" key={oIndex}>
                <label className={'ai-draft-right-toggle' + (option.isRight ? ' is-right' : '')}>
                  <input
                    type="checkbox"
                    checked={!!option.isRight}
                    onChange={e => updateOption(qIndex, oIndex, { isRight: e.target.checked })}
                  />
                  ✓
                </label>
                <input
                  type="text"
                  className="ai-draft-option-text"
                  value={option.text}
                  onChange={e => updateOption(qIndex, oIndex, { text: e.target.value })}
                />
                <input
                  type="number"
                  className="ai-draft-option-points"
                  value={option.points}
                  onChange={e => updateOption(qIndex, oIndex, { points: Number(e.target.value) })}
                />
                <span className="ai-draft-remove" onClick={() => removeOption(qIndex, oIndex)}>
                  <IconRemove />
                </span>
              </div>
            ))}
            <div className="ai-draft-add-option" onClick={() => addOption(qIndex)}>
              <IconAdd /> Додати варіант
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
